import clsx from 'clsx';

import styles from './Spinner.module.scss';

interface SpinnerProps {
  /** Diameter preset. Defaults to `'large'`. */
  size?: 'extraSmall' | 'small' | 'large';
  /** When true, uses the accent color instead of the default neutral. */
  useAccentColor?: boolean;
}

/**
 * Indeterminate loading indicator — a continuously rotating ring.
 *
 * Use for short, unbounded waits where there's no progress to report.
 * For richer placeholder layouts while content is loading, use
 * `SkeletonLoader` instead.
 */
export const Spinner = ({
  size = 'large',
  useAccentColor = false,
}: SpinnerProps) => (
  <div
    className={clsx(styles.spinner, styles[size], {
      [styles.accent]: useAccentColor,
    })}
    data-testid="spinner"
  />
);
